import { render, staticRenderFns } from "./MerchantView.vue?vue&type=template&id=447ee4fe"
import script from "./MerchantView.vue?vue&type=script&lang=js"
export * from "./MerchantView.vue?vue&type=script&lang=js"
import style0 from "./MerchantView.vue?vue&type=style&index=0&id=447ee4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports